var React = require('react');

function SocialLinkedin (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.32344 7.23288H4.97969V18H1.32344V7.23288ZM14.4156 6.87671C12.8125 6.87671 11.8562 7.45205 10.8438 8.71233V7.23288H7.1875V18H10.8719V12.1644C10.8719 10.9315 11.5187 9.72603 12.9812 9.72603C14.4437 9.72603 15.3156 10.9315 15.3156 12.137V18H19V11.8904C19 7.64384 16.0469 6.87671 14.4156 6.87671ZM3.16562 2C1.95625 2 1 2.84932 1 3.89041C1 4.93151 1.95625 5.78082 3.16562 5.78082C4.375 5.78082 5.33125 4.93151 5.33125 3.89041C5.33125 2.84932 4.375 2 3.16562 2Z","fill":"#22202F"}));
}

SocialLinkedin.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = SocialLinkedin;

SocialLinkedin.default = SocialLinkedin;
